import { graphqlApolloClient } from "../graphql-apollo-client"
import { UPDATE_SUSTAINABILITY_DETAILS } from "./graphql/mutations/updateSustainabilityDetails"

export const editSustainabilityDetails = async ({ id, ...data }) => {
  const { data: responseData } = await graphqlApolloClient.mutate({
    mutation: UPDATE_SUSTAINABILITY_DETAILS,
    variables: {
      data: data,
      id: id
    }
  })

  return responseData?.UpdateSustainabilityDetails
}